export default function StatusSemanticNote({ state = "info", message }) {
  const tone = TONE[state] || TONE.info;
  return (
    <div className={`mt-4 border px-3 py-2 text-xs font-mono ${tone}`} role="status" aria-live="polite">
      {message}
    </div>
  );
}

const TONE = {
  info: "border-[var(--border-default)] text-[var(--text-secondary)] bg-[var(--bg-surface)]",
  loading: "border-[#3F3F46] text-[var(--text-secondary)] bg-[var(--bg-surface)]",
  success: "border-[var(--primary)]/40 text-[var(--primary)] bg-[#11140A]",
  warning: "border-[#EAB308]/40 text-[#FACC15] bg-[#191407]",
  error: "border-[var(--error)]/40 text-[var(--error)] bg-[#1A1010]",
  readonly: "border-[#60A5FA]/40 text-[#93C5FD] bg-[#0D1420]",
  disabled: "border-[#3F3F46] text-[var(--text-tertiary)] bg-[#0F0F10]",
};
